import React from "react";
import { useMitcidco } from "./MitcidcoLayout";
import { PageHero, Section } from "./_shared";
import { Phone, Mail, MapPin, Clock, Send } from "lucide-react";

export default function Contact() {
  const data = useMitcidco();
  const inst = data?.institute || {};
  const address = "Plot No. 37, MIT Campus, CIDCO N-4, Chhatrapati Sambhajinagar, Maharashtra — 431003";
  const mapQuery = encodeURIComponent(`Marathwada Private Industrial Training Institute CIDCO N-4 Chhatrapati Sambhajinagar Aurangabad`);

  return (
    <div data-testid="mitcidco-contact">
      <PageHero
        eyebrow="Get in Touch"
        title="Visit our campus, or reach us online"
        sub="Parents, students and industry partners are welcome at our CIDCO N-4 campus any working day. Reach us by phone or email — our admissions cell responds promptly."
      />
      <Section>
        <div className="grid md:grid-cols-[1.1fr_1fr] gap-8">
          <div className="space-y-4">
            <Row icon={<MapPin />} label="Address">{address}</Row>
            {inst.admission_phone && (
              <Row icon={<Phone />} label="Phone">
                <a href={`tel:${inst.admission_phone.replace(/\s+/g, "")}`} className="hover:text-[#B45309]">{inst.admission_phone}</a>
                <div className="text-xs text-slate-500 mt-0.5">Alt: 9325213062</div>
              </Row>
            )}
            {inst.email && (
              <Row icon={<Mail />} label="Email">
                <a href={`mailto:${inst.email}`} className="hover:text-[#B45309] break-all">{inst.email}</a>
                <div className="text-xs text-slate-500 mt-0.5">Alt: mitmapatil@gmail.com</div>
              </Row>
            )}
            <Row icon={<Clock />} label="Office Hours">
              Monday – Saturday · 10:00 am – 5:00 pm<br />
              <span className="text-xs text-slate-500">Closed on public holidays</span>
            </Row>
            <div className="grid grid-cols-2 gap-3 pt-2">
              <a href={`tel:${(inst.admission_phone || "").replace(/\s+/g, "")}`} className="inline-flex items-center justify-center gap-2 bg-[#D4A017] hover:bg-[#B58007] text-[#5B1A0A] font-bold text-sm uppercase tracking-wider px-5 py-3.5 transition-colors" data-testid="mitcidco-contact-call">
                <Phone size={14} /> Call Now
              </a>
              <a href={`mailto:${inst.email || ""}`} className="inline-flex items-center justify-center gap-2 border-2 border-[#7C2D12] text-[#7C2D12] font-bold text-sm uppercase tracking-wider px-5 py-3.5 hover:bg-[#7C2D12] hover:text-white transition-colors" data-testid="mitcidco-contact-email">
                <Send size={14} /> Email Us
              </a>
            </div>
          </div>
          <div>
            <div className="border border-amber-100 overflow-hidden aspect-[4/3] bg-slate-100">
              <iframe
                title="Marathwada Pvt. ITI CIDCO — Map"
                src={`https://www.google.com/maps?q=${mapQuery}&output=embed`}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                data-testid="mitcidco-contact-map"
              />
            </div>
          </div>
        </div>
      </Section>
    </div>
  );
}

function Row({ icon, label, children }) {
  return (
    <div className="bg-white border border-amber-100 p-5 flex items-start gap-4">
      <div className="w-10 h-10 shrink-0 flex items-center justify-center bg-[#D4A017]/15 text-[#B45309]">{icon}</div>
      <div>
        <div className="text-[10px] tracking-[0.3em] uppercase text-slate-500 font-bold">{label}</div>
        <div className="mt-1 text-sm text-slate-800 leading-relaxed">{children}</div>
      </div>
    </div>
  );
}
